module.exports = __webpack_public_path__ + "static/logo-3@2x-89e9da29a02428e6ed50dfba3c494b4f.png";